import LTR from "@brand-icons/ploom/emoji-face-sad/emoji-face-sad-ltr.svg";

import { iconFactory } from "../iconFactory";

export const EmojiFaceSadIcon = iconFactory("EmojiFaceSadIcon", LTR);
